export default __webpack_public_path__ + "static/media/contextual-chocolate-lyte@3x.0215e234.png";